import { MessageTypes } from '@dupe/common/constants'
import { useEffect, useState } from 'react'
import usePostMessageListener from '~/src/hooks/usePostMessageListener'

const useExtensionState = () => {
  const [extensionState, setExtensionState] = useState<{
    loading: boolean
    installed?: boolean
    version?: string
    mobileSafariExtension?: boolean
  }>({
    installed: false,
    loading: true,
  })

  const postMessageListener = async (messageType: string, data: any) => {
    switch (messageType) {
      // use both AUTH_SYNC and PING to check if extension is installed
      // for backward compatibility
      case MessageTypes.AUTH_SYNC:
      case MessageTypes.PING: {
        const isMobileSafari = data?.extension === 'dupe-safari-ios'

        setExtensionState((prev) => ({
          ...prev,
          loading: false,
          installed: true,
          mobileSafariExtension: isMobileSafari,
          ...(data?.version && {
            version: data?.version,
          }),
        }))
        break
      }
      default:
        break
    }
  }

  usePostMessageListener('useExtensionState', postMessageListener)

  // Simulate loading state
  useEffect(() => {
    const timer = setTimeout(() => {
      setExtensionState((prev) => ({
        ...prev,
        loading: false,
      }))
    }, 2000)

    return () => clearTimeout(timer)
  }, [])

  return extensionState
}

export default useExtensionState
